import { apiClient } from './client';
import type { Announcement, CreateAnnouncementRequest, UpdateAnnouncementRequest } from '../types';

export const announcementsApi = {
  getAll: async (): Promise<Announcement[]> => {
    const response = await apiClient.get<Announcement[]>('/api/announcements');
    return response.data;
  },

  getById: async (id: number): Promise<Announcement> => {
    const response = await apiClient.get<Announcement>(`/api/announcements/${id}`);
    return response.data;
  },

  create: async (data: CreateAnnouncementRequest): Promise<Announcement> => {
    const response = await apiClient.post<Announcement>('/api/announcements', data);
    return response.data;
  },

  update: async (id: number, data: UpdateAnnouncementRequest): Promise<Announcement> => {
    const response = await apiClient.put<Announcement>(`/api/announcements/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/announcements/${id}`);
  },
};
